$(function() {
	if (location.search.indexOf('modal_off=1') === -1) {
		// 初期表示のモーダル
		// ※lp4の診断結果からもう一度診断するを押した場合、モーダルは出さない
		landingModal();
	}
	// エリア選択スライド
	areaSelectSlide();

	// エリア選択コンテンツ
	areaSelectContents();
});

/**
 * スクロールイベントを禁止する
 * モーダル表示時のバックグラウンドスクロールを防止する
 * @param {Event} event イベントオブジェクト
 */ 
function noScroll(event) {
	event.preventDefault();
}

/**
 * 初期表示モーダルを制御する
 * エリア選択モーダルの表示・非表示、都道府県/市区町村/路線/駅の選択処理を行う
 */
function landingModal(){
	// オーバーレイを表示
	$(".js-modal-window-box-select-area").fadeIn("fast", function() {
		modalArea = $(".js-modal-select-area");
		modalArea.children(".js-modal-window-box-inner").fadeIn();	
		// スクロールイベント自体を禁止する
		document.addEventListener('touchmove', noScroll, { passive: false });
	});
	// 閉じるボタンでモーダルウィンドウを閉じる
	$(document).on('click', '.js-modal-window-close', function() {
		// クリックしたボタンと同じ要素のモーダルウィンドウを閉じる
		modalArea = $(".js-modal-window");
		modalArea.children(".js-modal-window-box-select-area").fadeOut();
		modalArea.children(".js-modal-window-box-inner").fadeOut();
		// スクロールイベントの禁止を元に戻す
		document.removeEventListener('touchmove', noScroll, { passive: false });
	});
	// オーバーレイクリックでモーダルウィンドウを閉じる
	$(document).on('click', '.js-modal-window-box-select-area', function() {
		// モーダルが表示しきっていないと無効
		if ($('.js-modal-window-box-select-area').is(':visible') && $('.js-modal-window-box-inner').is(':visible')) {
			$(".js-modal-window-box-select-area:visible").fadeOut();
			$(".js-modal-window-box-inner:visible").fadeOut();
			// スクロールイベントの禁止を元に戻す
			document.removeEventListener('touchmove', noScroll, { passive: false });
		}
	});

	// 都道府県選択時に市区町村を取得
	$('select[name="pref"]').on('change', function() {
		const prefCd = $(this).val();
		const tabActiveClass = 'selectModal-tab__active'
		let getCityFlag = false;
		let getLineFlag = false;
		if ($(".js-modal-tab-city").hasClass(tabActiveClass)) {
			// 市区町村タブ選択
			getCityFlag = true;
		} else {
			// 路線・駅タブ選択
			getLineFlag = true;
		}
		if (getCityFlag) {
			// 市区町村をクリア
			$('select[name="city"]').children('option:not(:first-child)').remove();
			if (prefCd){
				$.ajax({
					type: "POST",
					url: "/city/get_combo_list_by_pref/" + prefCd,
					data: { is_json: 1}
				}).done(function( res ) {
					$.each(res.list, function(k, v) {
						$('select[name="city"]').append($('<option>').html(v['City']['s_place_name']).val(v['City']['s_place_cd']));
					});
				});
			}
		}
		if (getLineFlag) {
			// 路線をクリア
			$('select[name="line"]').children('option:not(:first-child)').remove();
			// 駅をクリア
			$('select[name="station"]').children('option:not(:first-child)').remove();
			if (prefCd){
				$.ajax({
					type: 'POST',
					url: '/line/get_combo_list_by_pref/' + prefCd,
					data:{ is_json: 1}
				}).done(function( res ) {
					$.each(res.list, function(k, v) {
						$('select[name="line"]').append($('<option>').html(v['Line']['line_name']).val(v['Line']['line_cd']));
					});
				});
			}
		}
	});

	// 路線変更
	$('select[name="line"]').on('change', function() {
		const lineCd = $(this).val();
		// 駅をクリア
		$('select[name="station"]').children('option:not(:first-child)').remove();
		if (lineCd){
			$.ajax({
				type: 'POST',
				url: '/station/get_combo_list_by_pref/',
				data:{
					line_cd: lineCd
				}
			}).done(function(res) {
				$.each(res.list, function(k, v) {
					$('select[name="station"]').append($('<option>').html(v['Station']['station_name']).val(v['Station']['station_cd']));
				});
			});
		}
	});
	// 駅選択後、LP4に遷移させる
	$('select[name="station"]').on('change', function() {
		var stationCd = $(this).val();
		if (stationCd){
			window.location.href = createLp4Url('', stationCd);
		}
	});

	// 市区町村選択後、LP4に遷移させる
	$('select[name="city"]').on('change', function() {
		var cityCd = $(this).val();
		if (cityCd){
			gtag('event', 'area_modal', {
				"TheEventAction": "click",
				"TheEventLabel" : "city_select",
				'non_interaction': true
			});
			window.location.href = createLp4Url(cityCd, '');
		}
	});
}

/**
 * エリア選択スライドパネルを制御する
 * スライドパネルの開閉、都道府県/市区町村/路線/駅の選択とLP4への遷移を行う
 */
function areaSelectSlide() {
	// 対象のクラス名に付く文字列
	var slideClassName = 'js-search-change';
	// エレメントの指定名を取得する正規表現を定義
	var regexp = new RegExp(slideClassName + '-([^ ]*)');
	// エリア選択スライド切り替え
	$(document).on('click', "[class*='" + slideClassName + "']", function() {
		$('[class^="js-search-panel"]').scrollTop(0);
		var classArr = this.className.match(regexp);
		var action = classArr[1];
		// 次のスライドを表示
		$('.js-search-panel-' + action).addClass('selectPanel__show');
		// スクロール位置固定
		$('body').css('position', 'fixed');
		$('body').css('width', '100%');
	});

	// 選択画面のブラウザバック時にそのページにとどまるようにする
	$('.js-search-area-hash').on('click', function() {
		window.location.hash = '#search-area';
	});

	// スライドパネル非表示
	$(document).on('click', '.js-search-close', function() {
		// 全パネル非表示
		$('[class^="js-search-panel"]').removeClass('selectPanel__show');
		// スクロール位置解除
		$('body').css('position', '');
		$('body').css('width', '');
		if (location.hash.length > 0){
			history.replaceState('', this.title, location.href.replace(location.hash, ''));
			history.back();
		}
	});

	// 都道府県選択時
	$(document).on('click', '.js-slide-pref-select', function() {
		// 市区町村取得
		$.ajax({
			type: "POST",
			url: "/iphone/biglp1/get_city_by_pref/",
			data:{ pref_cd: $(this).data('pref-cd')},
		}).done(function( res ) {
			// 市区スライドをセット
			$('.js-slide-city').html(res.response);
		});
		// 路線取得
		$.ajax({
			type: "POST",
			url: "/iphone/biglp1/get_line_by_pref/",
			data:{ pref_cd: $(this).data('pref-cd')},
		}).done(function( res ) {
			// 路線選択スライドをセット
			$('.js-slide-line').html(res.response);
		});
	});

	// 市区選択時
	$(document).on('click', '.js-slide-city-select', function() {
		// LP4へ遷移
		location.href = createLp4Url($(this).data('city-cd'), '');
	});

	// 路線選択時
	$(document).on('click', '.js-slide-line-select', function() {
		console.log($(this));
		// 駅取得
		$.ajax({
			type: "POST",
			url: "/iphone/biglp1/get_station_by_line/",
			data:{ pref_cd: $(this).data('pref-cd'), line_cd: $(this).data('line-cd')},
		}).done(function( res ) {
			// 駅選択スライドをセット
			$('.js-slide-station').html(res.response);
			// 駅
			$('.js-slide-station-text').html('駅を選択してください(' + res.pref.Prefecture.pref_nm + ')');
		});
	});

	// 「路線を変更」ボタン押下時
	$(document).on('click', '.js-search-back-line', function() {
		// 駅選択スライドを非表示
		$('.js-search-panel-station').removeClass('selectPanel__show');
		// 駅選択スライドを空にする
		$('.js-slide-station').html('');
	});

	// 駅選択時
	$(document).on('click', '.js-slide-station-select', function() {
		// LP4へ遷移
		location.href = createLp4Url('', $(this).data('station-cd'));
	});
}

/**
 * LP4のURLを生成する
 * 市区町村または駅コードからLP4のURLを生成し、必要なパラメータを付与する
 * @param {string} cityCd 市区町村コード
 * @param {string} stationCd 駅コード
 * @returns {string} 生成されたLP4のURL
 */
function createLp4Url(cityCd, stationCd) {
	lp4Url = '/iphone/lp4/'
	if(cityCd){
		// 市区町村
		lp4Url += cityCd + '.html';
	} else if(stationCd){
		// 駅
		lp4Url += 's' + stationCd + '.html';
	}
	// biglp1から遷移時の遷移先用のモーダルoffパラメータ付与
	lp4Url += '?modal_off=1';
	if(location.search.indexOf('kobetsu=1') !== -1){
		// 個別ランキング
		lp4Url += '&kobetsu=1';
	} else if(location.search.indexOf('shudan=1') !== -1){
		// 集団ランキング
		lp4Url += '&shudan=1';
	}
	return lp4Url;
}

/**
 * エリア選択コンテンツのタブ切り替えを制御する
 * 市区町村タブと路線・駅タブの表示切り替えを行う
 */
 function areaSelectContents() {
	const selectTabClassName = 'selectModal-tab';

	// 選択タブ切替(市区町村)
	$(document).on('click', '.js-modal-tab-city', function() {
		if(!$(this).hasClass('selectModal-tab__active')){
			$(".js-modal-tab-line").removeClass(selectTabClassName + "__active");
			$(this).addClass(selectTabClassName + "__active");
			$(".js-modal-tab-city-contents").removeClass("selectModal-line-contents__none");
			$(".js-modal-tab-line-contents").addClass("selectModal-line-contents__none");
		}
	});
	// 選択タブ切替(路線・駅)
	$(document).on('click', '.js-modal-tab-line', function() {
		if(!$(this).hasClass('selectModal-tab__active')){
			$(".js-modal-tab-city").removeClass(selectTabClassName + "__active");
			$(this).addClass(selectTabClassName + "__active");
			$(".js-modal-tab-city-contents").addClass("selectModal-line-contents__none");
			$(".js-modal-tab-line-contents").removeClass("selectModal-line-contents__none");
		}
	});
}

/**
 * ハッシュ値変更時
 */
window.addEventListener('hashchange', e => {
	// エリア選択スライドが開いていて、#search-area以外のハッシュ値に書き変わった場合#search-areaに戻す
	if ($('.selectPanel__show').is(':visible') && location.hash.length > 0 && location.hash != '#search-area') {
		history.replaceState('', this.title, location.href.replace(location.hash, '#search-area'));
		history.back();
	// エリア選択スライドが開いていてハッシュ値が設定されていない場合スライドを閉じる
	} else if($('.selectPanel__show').is(':visible') && location.hash.length < 1) {
		$('.js-search-close').click();
	}
}, false);

// ページ読み込み時ハッシュがある場合取り除く
if (location.hash.length > 0 && !$('.selectPanel__show').is(':visible')) {
	history.replaceState('', this.title, location.href.replace(location.hash, ''));
}

/**
 * スクロール処理
 */
 $(window).scroll(function () {
	// 現在のスクロール下部位置
	var pageBottom = $(document).scrollTop() + $(window).height();
	// 表示終了位置
	var pagetopBand = 0;
	if ($('#scroll-footer-end').offset() != undefined) {
		pagetopBand = $('#scroll-footer-end').offset().top;
	}
	// 現在のスクロール下部位置が表示終了位置より小さいかつ、現在のスクロール位置が0より大きい場合、追従を表示
	if (pageBottom <= pagetopBand && 0 < $(document).scrollTop()) {
		$('.js-follow-btn').show();
	} else {
		$('.js-follow-btn').hide();
	}
});